import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Konaklama.css';

function Konaklama() {
  const oteller = [
    {
      ad: "Sivas Eretna Oteli",
      uzaklik: "500 metre",
      fiyatlar: ["Tek kişilik oda: 2500", "İki kişilik oda: 3500", "Üç kişilik oda: 4500"],
      web: "https://www.eretnahotel.com/"
    },
    {
      ad: "SİVAS KÖŞK OTELİ",
      uzaklik: "300 metre",
      fiyatlar: ["Tek kişilik oda: 1800", "İki kişilik oda: 2800"],
      web: "http://www.koskotel.com/tr/"
    },
    {
      ad: "SİVAS SULTAN OTELİ",
      uzaklik: "400 metre",
      fiyatlar: ["Tek kişilik oda: 2400", "İki kişilik oda: 3400"],
      web: "https://sultanotel.com.tr/"
    },
    {
      ad: "Sivas Öğretmenevi",
      uzaklik: "1500 metre",
      fiyatlar: ["Tek kişilik oda: 1500", "İki kişilik oda: 2000"],
      web: "https://sivas.mebogretmenevi.com.tr/booking/"
    },
    {
      ad: "Sivas Ramada Otel",
      uzaklik: "2 Km",
      fiyatlar: ["Tek kişilik oda: 3000", "İki kişilik oda: 4000"],
      web: "https://www.ramadasivas.com/"
    },
    {
      ad: "Sivas Büyük Otel",
      uzaklik: "500 metre",
      fiyatlar: ["Tek kişilik oda: 2900", "İki kişilik oda: 3500"],
      web: "http://www.sivasbuyukotel.com/"
    }
  ];

  return (
    <div className="konaklama-page">
      <Navbar />

      <header className="page-hero">
        <div className="container">
          <h2>KONAKLAMA</h2>
          <p>Kongre Katılımcılarına Özel İndirimli Konaklama Seçenekleri</p>
        </div>
      </header>

      <main className="content-container">
        <section className="accommodation-section">
          <h3><i className="fas fa-hotel"></i> Anlaşmalı Oteller ve Fiyat Listesi</h3>

          <div className="table-wrapper">
            <table className="accommodation-table">
              <thead>
                <tr>
                  <th>OTEL ADI</th>
                  <th>ŞEHİR MERKEZİNE UZAKLIK</th>
                  <th>ODA FİYATI (TL)</th>
                  <th>WEB ADRESİ</th>
                </tr>
              </thead>
              <tbody>
                {oteller.map((otel, index) => (
                  <tr key={index}>
                    <td className="hotel-name"><strong>{otel.ad}</strong></td>
                    <td>{otel.uzaklik}</td>
                    <td>
                      {otel.fiyatlar.map((fiyat, i) => (
                        <div key={i}>{fiyat}</div>
                      ))}
                    </td>
                    <td>
                      <a href={otel.web} target="_blank" rel="noopener noreferrer" className="web-link">
                        Web Sitesine Git
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Görseldeki kırmızı önemli not kısmı */}
          <div className="accommodation-important-note">
            <p>
              Tüm konaklama yerlerinde fiyatlara <strong>sabah kahvaltısı dâhil</strong> olup, 
              kalmak istediğiniz yere <strong>Kongre Katılımcısı olduğunuzu bildirmeniz</strong> yeterlidir. 
              Tablodaki fiyatlar sadece katılımcılara özel fiyatlardır. 
              Ramada otel, Eretna Otel ve Büyük Otelde <strong>9 yaşa kadar olan çocuklar ücretsiz</strong> kalabileceklerdir.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Konaklama;